import React from "react";
import "./VendorFormReview.scss";
import { QuestionSchema } from "../../models/QuestionForm";
import { INPUT_TYPE } from "../../constants/QuestionFormData";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

interface VendorFormReviewProps {
  allQuestions: QuestionSchema[];
  formTitle: string;
  formDescription: string;
  vendorTab?: boolean;
  requestForm?: boolean;
}

const VendorFormReview: React.FC<VendorFormReviewProps> = ({
  allQuestions,
  formTitle,
  formDescription,
  vendorTab,
  requestForm,
}) => {
  return (
    <div className="vendor-review-form-main-page flex-row justify-content-center">
      <div
        style={{ background: requestForm ? "white" : "" }}
        className={`vendor-form-review-main-container p-18 flex-column gap-18 ${
          vendorTab && "vendor-form-edits"
        }`}
      >
        {!requestForm && (
          <>
            <p className="xetgo-font-h3 bolder">{formTitle}</p>
            <p
              style={{
                color: "#626262",
              }}
              className="xetgo-font-button "
            >
              {formDescription}
            </p>
          </>
        )}
        {allQuestions.map((question, questionIndex) => (
          <div
            style={{ background: requestForm ? "#F8F9FA" : "" }}
            key={questionIndex}
            className="form-detail-question-container xetgo-font-tag flex-column gap-8 p-12"
          >
            <p className="question">
              {`${questionIndex + 1}. ${question.question_value}`}{" "}
              {question.isRequired && <span style={{ color: "red" }}>*</span>}
            </p>

            {/* text  */}
            {question.input_type == INPUT_TYPE[0].code && (
              <input
                className={`answer-input px-12 py-8 xetgo-font-tag full-width border-box ${
                  requestForm && "input-bg-white"
                }`}
                value={""}
                placeholder="Enter Answer"
                disabled
              />
            )}

            {/* para  */}
            {question.input_type == INPUT_TYPE[7].code && (
              <textarea
                className={`answer-input  px-12 py-8 xetgo-font-tag full-width border-box ${
                  requestForm && "input-bg-white"
                }`}
                value={""}
                placeholder="Enter Answer"
                disabled
              />
            )}

            {/* number  */}
            {question.input_type == INPUT_TYPE[1].code && (
              <input
                className={`answer-input px-12 py-8 xetgo-font-tag full-width border-box ${
                  requestForm && "input-bg-white"
                }`}
                value={""}
                placeholder="Enter Answer"
                disabled
              />
            )}

            {/* checkbox  */}
            {question.input_type === INPUT_TYPE[2].code && question.options && (
              <div className="option-container flex-column gap-16">
                {question.options.map((option, optionIndex) => (
                  <div
                    key={optionIndex}
                    className="flex-row align-items-center gap-10 options-container"
                  >
                    <input type="checkbox" className="check-box" disabled />
                    <input
                      type="text"
                      value={option.name}
                      className="check-text xetgo-font-tag "
                      disabled
                    />
                  </div>
                ))}
              </div>
            )}

            {/* radio  */}
            {question.input_type === INPUT_TYPE[3].code && question.options && (
              <div className="option-container flex-column gap-16">
                {question.options.map((option, optionIndex) => (
                  <div
                    key={optionIndex}
                    className="flex-row align-items-center gap-10 options-container"
                  >
                    <input
                      type="radio"
                      className="check-box radio-btn "
                      disabled
                    />
                    <input
                      type="text"
                      value={option.name}
                      className="check-text xetgo-font-tag "
                      disabled
                    />
                  </div>
                ))}
              </div>
            )}

            {/* single file  */}
            {question.input_type == INPUT_TYPE[4].code && (
              <div className="custom-form-left-box flex-1 flex-column gap-8">
                <input
                  id="single-fileInput"
                  name="file"
                  type="File"
                  style={{
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    display: "none",
                  }}
                  disabled={true}
                />
                <label
                  htmlFor="single-fileInput"
                  className={`answer-input px-12 py-8 xetgo-font-tag full-width border-box ${
                    requestForm && "input-bg-white"
                  }`}
                >
                  <p className="xetgo-font-tag flex-row justify-content-space-between">
                    <p>Upload File</p>
                    <img
                      className="upload-icon"
                      height={16}
                      width={16}
                      src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240828115442-upload+%287%29.svg"
                      alt="upload-icon"
                    />
                  </p>
                </label>
              </div>
            )}

            {/* multiple upload */}
            {question.input_type == INPUT_TYPE[5].code && (
              <div className="custom-form-left-box flex-1 flex-column gap-8">
                <input
                  id="multi-fileInput"
                  name="file"
                  type="File"
                  style={{
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    display: "none",
                  }}
                  disabled={true}
                />
                <label
                  htmlFor="multi-fileInput"
                  className={`answer-input px-12 py-8 xetgo-font-tag full-width border-box ${
                    requestForm && "input-bg-white"
                  }`}
                >
                  <p className="xetgo-font-tag flex-row justify-content-space-between">
                    <p>Upload File</p>
                    <img
                      className="upload-icon"
                      height={16}
                      width={16}
                      src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240828115442-upload+%287%29.svg"
                      alt="upload-icon"
                    />
                  </p>
                </label>
              </div>
            )}

            {/* date and time  */}
            {question.input_type == INPUT_TYPE[6].code && (
              <div className="custom-question-date-value xetgo-font-tag">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className={`answer-input px-12 py-8 xetgo-font-tag full-width border-box ${
                      requestForm && "input-bg-white"
                    } `}
                    value={dayjs("".split("-").reverse().join("-"))}
                    format={"DD-MM-YYYY"}
                    views={["year", "month", "day"]}
                    // onChange={(event) =>
                    //   handleDateChange(event?.toDate().toISOString())
                    // }
                    disabled
                  />
                </LocalizationProvider>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default VendorFormReview;
